import ReloadableRoute from "./ReloadableRoute";
export default ReloadableRoute;